export default {
  upload_common: {
    required: 'Esta pregunta es obligatoria',
    max_length_500: 'Favor responder dentro de 500 palabras.',
    please_enter_a_number: 'Ingresar números',
    unexpected_error: 'Ha ocurrido un error inesperado',
    temporarily_saved: 'Guardado',
    unanswered_items: 'Hay preguntas sin responder',
    answer_questionnaire_select: 'Seleccione un cuestionario',
    entry: 'Favor rellenar',
    target_select: 'Seleccionar',
    value_unit: 'Número',
    unit: 'Unidad',
    attach_documents: 'Adjuntar archivos',
    textarea_placeholder: 'Escriba su respuesta cuando se le requiera, o si desea agregar cualquier explicación adicional.',
    // textarea_placeholder_with_file: '',
    temporary_storage: 'Guardar',
    submit: 'Enviar',
    last_saved_temporary: 'Última actualización',
    There_are_unanswered_questions: 'Hay preguntas sin responder',
    submitted_text: 'La encuesta ha sido enviada.',
    submitted_at: 'Fecha de envío',
    withdrawal_of_answer: 'Retirar envío',
    withdrawal_accepted: 'Retiro aceptado',
    help: 'Ayuda',
    example_of_evidence: 'Ejemplo de prueba',
    save_temporary_answer: 'Guardar encuesta',
    saved_temporary_answer: 'Su respuesta se ha guardado.',
    submit_answer: 'Enviar encuesta',
    confirm_submit_answer: '¿Seguro de que desea enviar la encuesta?',
    confirm_submit_shared_text: '\nLas respuestas a su encuesta se compartirán con su comprador.',
    complete_submit_answer: 'La encuesta ha sido enviada.\nGracias por su colaboración.',
    // recommend_asuene: '',
    // not_at_all: '',
    // absolutely: '',
    // let_us_know_your_thoughts: '',
    // thank_you_for_your_cooperation: '',
    // glad_to_support: '',
    // confirm_submit_shared_text: '',
    back_answer: 'Volver',
    close: 'Cerrar',
    save_temporary_answer_and_prev: 'Guardar y volver atrás',
    save_temporary_answer_and_next: 'Guardar e ir al siguiente',
    prev: 'Atrás',
    next: 'Siguiente',
    question_group_question_download: 'Descargar encuesta',
    question_group_answer_download: 'Descargar respuestas',
    question_group_download_answer_csv_title: 'Pregunta・Respuestas(CSV)',
    question_group_download_answer_csv_description: 'Descargar respuestas en csv.',
    question_group_download_answer_pdf_title: 'Pregunta・Respuestas(PDF)',
    question_group_download_answer_pdf_description: 'Descargar respuestas en pdf.',
    question_group_download_scorecard_pdf_title: 'Tarjeta de puntaje(PDF)',
    question_group_download_scorecard_pdf_description: 'Descargar puntuación en pdf.',
    question_group_download_esg_award_svg_title: 'El premio ESG(SVG)',
    question_group_download_esg_award_svg_description: 'Descargar adjudicación en svg.',
    question_group_download_esg_award_pdf_title: 'El premio ESG(PDF)',
    question_group_download_esg_award_pdf_description: 'Descargar adjudicación en pdf.',
    request_survey_withdrawal: 'Solicitar retiro de la encuesta',
    survey_withdrawal_description: 'La solicitud de retiro se enviará a su Comprador.\nIndique a continuación el motivo por el que desea retirar su encuesta. Los detalles de su solicitud de retiro se compartirán con su Comprador.',
    reason_withdrawal_request: 'Razón para la solicitud de retiro',
    completed_withdrawal_request: 'Su solicitud de retiro fue aceptada. Espere a que se apruebe.',
    send: 'Enviar',
    cancel: 'Cancelar',
    balloon_title_withdrawal_request: 'Su solicitud de retiro fue aceptada.',
    no_survey: 'No hay solicitudes de encuesta disponibles.',
    failed_to_save_before_export: 'Error al guardar temporalmente antes de la descarga de.Compruebe que la información introducida sea correcta.',
    filter_unfilled_questions: 'Mostrar solo encuestas sin respuestas',
    no_unfilled_questions: 'No hay preguntas sin responder',
    move_page: 'Ir a la siguiente página',
    confirm_move_page_message: 'Sus respuestas no se han guardado \nSi cambia de página se perderán sus respuestas.¿Desea guardar sus respuestas antes de continuar?',
    confirm_without_save: 'No guardar',
    confirm_with_save: 'Guardar',
    error_save: 'No se puede guardar temporalmente. Compruebe sus respuestas.',
    // there_are_no_unanswered_questions: "",
    someone_editing_survey: 'Encuesta en edición.',
    unable_edit_someone_editing_survey: 'La encuesta no se puede editar en este momento por que ya hay un usuario editándola.',
    user_editing_survey: 'está editando actualmente.',
    reference_question: {
      // see_previous_answers: "",
      previous_answers: 'Respuestas anteriores',
      // overwrite_with_previous_answers: "",
      submitted_at: '(Enviada {submitted_at}',
      // related_question: "",
      click_to_expand: 'Haga clic para expandir',
      click_to_omit: 'Haga clic para emitir',
      // description: "",
      answer_reference_function: 'Función de referencia de respuesta',
      overwrite: 'Sobrescribir',
      overwrite_confirm: 'Esta acción completará las respuestas anteriores a preguntas ya respondidas en encuestas anteriores.\nCualquier pregunta que ya haya sido respondida será sobrescrita.',
      question_group: '@:question_group_section.list_header_question',
    },
    energy_question: {
      scope: 'Scope',
      item: 'Artículo',
      activity_amount: 'Cantidad',
      emission_factor: 'Factor de emisión',
      emission_amount: 'Emisiones',
      unit_sale: 'Intensidad de las emisiones',
      total: 'Total',
      emission_amount_unit: 'tCO2',
      unit_sale_unit: 'tCO2/un millón de YENES',
    },
    label: {
      required_answer: 'Respuesta obligatoria.',
      optional_answer: 'Respuesta opcional',
      conditional_required_answer: 'Respuesta obligatoria de la ramificación',
      note: 'Nota',
      // evidence_attachments: "",
    },
    // no_available_in_pdf: ''
    // comparison_question_meta: '',
    // error_footer: '',
    // error_panel_title: '',
    // error_panel_description: '',
    // error_panel_support_text_1: '',
    // error_panel_support_label: '',
    // error_panel_support_text_2: '',
    // error_panel_resolved: '',
    // error: '',
    // error_revision_required: '',
    // alert: '',
    // alert_detected: ''
    question_group_download_answered_csv_title: 'Pregunta・Respuesta(CSV)',
    question_group_download_answered_pdf_title: 'Pregunta・Respuesta(PDF)',
  }
}
